export default __webpack_public_path__ + "static/media/benefits-landing-preview-desktop-celebration.a52a498f.png";